// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2OiD5","buttons":"SendReceipts_buttons__2H3XH","email":"SendReceipts_email__go7tY","bookApptTitle":"SendReceipts_bookApptTitle__TJ4Tv"};